import {
  CssBaseline,
  IconButton,
  TextField,
  Tooltip,
  Typography,
  Button,
} from "@mui/material";
import {
  DashboardLayout,
  SidebarFooterProps,
} from "@toolpad/core/DashboardLayout";
import React, { useState } from "react";
import SearchIcon from "@mui/icons-material/Search";
import AddIcon from "@mui/icons-material/Add";
import { Outlet } from "react-router-dom";
import { PageContainer } from "@toolpad/core/PageContainer";
import { useTaskDialog } from "../context/task-dialog";
import { ActionPermissionGuard } from "../utilities/permissions";
import { BootstrapTooltip } from "../utilities";
import GlobalTaskDialog from "../components/GlobalTaskDialog";
export default function Layout() {
  function SidebarFooter({ mini }: SidebarFooterProps) {
    return (
      <Typography
        variant="caption"
        sx={{ m: 1, whiteSpace: "nowrap", overflow: "hidden" }}
      >
        {mini
          ? "© Agrin"
          : `© ${new Date().getFullYear()} شرکت آگرین-09134572676`}
      </Typography>
    );
  }
  const [drawerOpen, setDrawerOpen] = useState(false);
  function Search() {
    const { openTaskDialog } = useTaskDialog();

    return (
      <React.Fragment>
        {/* <ActionPermissionGuard menuId="duties" permission="create"> */}
        <BootstrapTooltip title="وظیفه جدید">
          <Button
            variant="contained"
            color="primary"
            onClick={openTaskDialog}
            sx={{ mr: 1 }}
            startIcon={<AddIcon />}
          >
            وظیفه جدید
          </Button>
        </BootstrapTooltip>
        {/* </ActionPermissionGuard> */}
        {/* <Tooltip title="جستجو" enterDelay={1000}>
          <div>
            <IconButton
              type="button"
              aria-label="search"
              sx={{
                display: { xs: "inline", md: "none" },
              }}
            >
              <SearchIcon />
            </IconButton>
          </div>
        </Tooltip>
        <TextField
          label="جستجو"
          variant="outlined"
          size="small"
          slotProps={{
            input: {
              endAdornment: (
                <IconButton type="button" aria-label="search" size="small">
                  <SearchIcon />
                </IconButton>
              ),
              sx: { pr: 0.5 },
            },
          }}
          sx={{ display: { xs: "none", md: "inline-block" }, mr: 1 }}
        /> */}
      </React.Fragment>
    );
  }
  return (
    <DashboardLayout
      slots={{ toolbarActions: Search, sidebarFooter: SidebarFooter }}
      onDrawerToggle={() => setDrawerOpen((prev) => !prev)}
    >
      <PageContainer
        maxWidth={false}
        sx={{
          transition: "all 0.3s ease",
          width: "100%",
          maxWidth: "100%",
        }}
      >
        <CssBaseline />
        <Outlet />
      </PageContainer>
      <GlobalTaskDialog />
    </DashboardLayout>
  );
}
